﻿$.fn.dxCtrlPagePlanitiReunionExterne = function custom_dxCtrlPagePlanitiReunionExterne(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpageplanitireunionexterne dx-ctrl");
        this.createInstance(new cdxCtrlPagePlanitiReunionExterne(this, option));
    }
    return this;
}

window.cdxCtrlPagePlanitiReunionExterne = function (container, option) {
    var Me = this;
    //parametre.isPhone=true

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();
        container.css({
            width: "100%",
            height: "100%",
            display: "flex",
            "justify-content": "center",
            "align-items": "center"
        })
        if (typeof option.dataPlaniti == 'undefined') {
            option.bddCtrl.mAjaxCall({ command: "getdataplaniti", id_planiti: option.idPlaniti }, function (data) {
                option.dataPlaniti = data
                if (typeof option.dataPlaniti.planiti == 'undefined') {
                    option.dataPlaniti.planiti = null
                } else {
                    option.dataPlaniti.planiti = option.dataPlaniti.planiti[0]
                }
                mRempli()
            })
        } else {
            mRempli()
        }

    }

    function mRempli() {
        container.empty();
        container.css("position", "relative")
        mRempliPageChoix()
    }

    var dxPageChoix = null
    function mRempliPageChoix() {
        dxPageChoix = $("<div style='height:100%;width:100%;mx-width:1200px;max-height:800px;position:absolute;z-index:0;'/>").appendTo(container).dxCtrlPagePlanitiReunionExterneChoix({
            bddCtrl: option.bddCtrl,
            dataPlaniti: option.dataPlaniti,
            idPlanitiReunion: option.idPlanitiReunion,
            idPlanitiReunionOrga: option.idPlanitiReunionOrga,
            reprogrammation: option.reprogrammation,
            isInterne: option.isInterne
        }).dxCtrlPagePlanitiReunionExterneChoix("instance")
    }

    //var dxFinalReunion = null
    //function mRempliPageFinalReunion(idPlanitiReunion) {
    //    dxPageChoix.element().fadeOut(300, function () { dxPageChoix.element().remove() })
    //    dxFinalReunion = $("<div style='height:100%;width:100%;max-height:800px;position:absolute;z-index:1;display:none'/>").appendTo(container).dxCtrlPagePlanitiReunionFinal({
    //        bddCtrl: option.bddCtrl,
    //        dataPlaniti: option.dataPlaniti,
    //        hideButonCancelReprogramme: (typeof option.idPlanitiReunion == 'undefined'),
    //        idPlanitiReunion: idPlanitiReunion
    //    }).dxCtrlPagePlanitiReunionFinal("instance")
    //    dxFinalReunion.element().fadeIn(300)
    //    option.idPlanitiReunion = idPlanitiReunion
    //}

    this.mUpdate = function () {
        mRempli()
    }

    this.mUpdateDetail = function () {
        dxPageChoix.mUpdateDetail()
    }

    this.mUpdateHeure = function () {
        dxPageChoix.mUpdateHeure()
    }

    this.element = function () { return container; }

    mConstruit();
}